





















































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';

import {
  Utils,
  DataBus,
  InputError,
  TireStoringContract,
  TireStoringInfo,
  TireContractHistory,
  DataTableRequest,
  TireTypeEnum,
  TireSize,
  TireWidth,
  TireWear,
  TireBrand,
  EnumObject,
  ResponseCodeEnum,
  UserDetail,
  RoleEnum,
  ContractPeriodEnum,
  ContractStatusEnum,
  Location
} from '@/models';
import {
  loginService,
  tireStoringContractService,
  tireContractHistoryService,
  tireSizeService,
  tireWearService,
  tireWidthService,
  tireBrandService,
  imageService,
  toastService,
  locationService
} from '@/services';

import TireInfoCard from '@/components/tire/info/TireInfoCard.vue';
import TireContractHistoryViewer from '@/components/tire/history/TireContractHistoryViewer.vue';
import { ValueSteps } from "./ValueSteps";

// @ts-ignore
import Loading from 'vue-loading-overlay';

@Component({
  components: {
    TireInfoCard,
    TireContractHistoryViewer,
    Loading,
  },
})
export default class TireContractDetailPage extends Vue {
  private isLoading: boolean = false;
  private isAgency: boolean = false;
  private isWarehouse: boolean = false;
  private isBtjCompany: boolean = false;
  private showConfirmTireSwitch: boolean = false;
  private showConfirmFinishedModal: boolean = false;
  private showConfirmCancelPickupModal: boolean = false;
  private showConfirmCancelDeliveryModal: boolean = false;
  private showConfirmCompleteModal: boolean = false;
  private showConfirmRenewModal: boolean = false;
  private showSwitchButton: boolean = false;
  private statusInWarehouse: number = ContractStatusEnum.IN_WAREHOUSE;
  private statusRequestPickup: number = ContractStatusEnum.REQUEST_PICKUP;
  private statusAcceptedDelivery: number = ContractStatusEnum.REQUEST_DELIVERY;
  private statusComplete: number = ContractStatusEnum.COMPLETED;
  private showTabSummer: boolean = true;
  private showTabWinter: boolean = true;
  private showCollapse: boolean = false;

  private tireBrandDefaultOption: TireBrand = new TireBrand();

  private tireContract: TireStoringContract = new TireStoringContract();
  private tireContractHistories: TireContractHistory[] = [];
  private contractPeriodOptions: EnumObject[] = [];
  private contractStatusOptions: EnumObject[] = [];
  private tireSizeOptions: TireSize[] = [];
  private tireWearOptions: TireWear[] = [];
  private tireWidthOptions: TireWidth[] = [];
  private tabIndex: number = 1;
  private activeTabSummer: boolean | null = null;
  private activeTabWinter: boolean | null = null;
  private isExpired: boolean = false;
  private expiredFee: number = 0;

  private isEditLocationNo: boolean = false;
  private RoleEnum = RoleEnum;
  private user: UserDetail | undefined = this.$store.state.user;

  private errors: InputError[] = [
    { field: 'rackLocation', isError: undefined, message: [] },
    { field: 'columnLocation', isError: undefined, message: [] },
    { field: 'rowLocation', isError: undefined, message: [] },
  ];

  private getInputError(field: string): InputError | undefined {
    const inputError = this.errors.find((e) => e.field === field);   
    return inputError ? inputError : undefined;
  }

  private onInputChange(field: string) {
    const inputError = this.errors.find((e) => e.field === field);
    if (inputError) {
      inputError.isError = undefined;
    }
  }

  private created() {
    // Check user role
    // const user: UserDetail | undefined = this.$store.state.user;
    if (this.user && this.user.role === RoleEnum.ROLE_AGENCY) {
      this.isAgency = true;
    } else if (this.user && this.user.role === RoleEnum.ROLE_WAREHOUSE) {
      this.isWarehouse = true;
    } else if (this.user && this.user.role === RoleEnum.ROLE_BTJ_COMPANY) {
      this.isBtjCompany = true;
    }
    this.loadTireOptions();

    // Load tire contract history
    if (!this.$route.params.id) {
      this.back();
    }
    const contractId = this.$route.params.id;
    this.loadTireContract(contractId);
    this.loadTireContractHistory(contractId);
    this.setDefaultTireBrand();
  }

  private back() {
    this.$router.push({ name: 'routes.search_tire_contract' });
  }

  private backToMatterScreen() {
      window.location.href = process.env.VUE_APP_ROOT_API + '/admin/contracts/list';
  }

  private genLocationNo() {
    return (this.tireContract.rackLocation || '') + (this.tireContract.columnLocation || '') + (this.tireContract.rowLocation || '');
  }

  private loadTireContract(contractId?: string) {
    if (!contractId) {
      return;
    }
    this.isLoading = true;
    tireStoringContractService.get(contractId)
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          this.tireContract = res.data.data;
          // Show summer/winter tab
          if (this.tireContract.period === ContractPeriodEnum.SIX_MONTH) {
            this.showTabSummer = this.tireContract.tireType === TireTypeEnum.SUMMER;
            this.showTabWinter = this.tireContract.tireType === TireTypeEnum.WINTER;
          } else {
            this.showTabSummer = true;
            this.showTabWinter = true;
          }
          if (this.tireContract.tireType === TireTypeEnum.SUMMER) {
            this.activeTabSummer = true;
          } else {
            this.activeTabWinter = true;
          }
          // Show switch tire button
          this.showButtonStatus(this.tireContract);
          const dateLeft: number = parseInt(this.getDayLeft(this.tireContract));
          if (dateLeft < 0 && (this.tireContract.status === ContractStatusEnum.IN_WAREHOUSE
              || this.tireContract.status === ContractStatusEnum.REQUEST_DELIVERY
              || this.tireContract.status === ContractStatusEnum.ACCEPTED_DELIVERY)) {
            this.isExpired = true;
            tireStoringContractService.getExpiredFeeOfContract(contractId)
            .then((res) => {
              this.expiredFee = res.data.data ? res.data.data : 0;
            })
          }
        } else {
          this.$router.back();
        }
      })
      .finally(() => this.isLoading = false);
  }

  private updateLocationNo() {
    locationService.checkExist({
      shelf1: this.tireContract.rackLocation,
      shelf2: this.tireContract.columnLocation,
      shelf3: this.tireContract.rowLocation
    } as Location
    ).then((res) => {
      if(res.data.data) {
        this.isLoading = true;
        tireStoringContractService
          .updateLocationNo(this.tireContract)
          .then((res) => {
            if(res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
              // this.tireContract = res.data.data;
              this.isEditLocationNo = false;
              this.loadTireContractHistory(this.$route.params.id);
              toastService.success(this.$t('view.tire_register.message.contract_updated').toString() + res.data.data.slipNo);
            }
          })
          .catch((error) => {
            if (error.response.status === 400) {
              error.response.data.errors.forEach((err: any) => {
                const inputError = this.errors.find((e) => e.field === err.field);          
                if (inputError !== undefined) {
                  if (inputError.isError === undefined) {
                    inputError.isError = false;
                    inputError.message = [];
                  }
                  inputError.message.push(err.defaultMessage);
                }
              });
            }
          })
          .finally(() => this.isLoading = false);

      } else {
        toastService.errorMessage('common.message.tire_location_not_exist');
      }
    })

    
  }

  private loadTireContractHistory(contractId: string) {
    tireContractHistoryService.getAllByContract(contractId)
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.items) {
          this.tireContractHistories = res.data.items;
        }
      });
  }

  private loadTireOptions() {
    tireStoringContractService.getContractPeriod()
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          this.contractPeriodOptions = res.data.data;
        }
      });
    tireStoringContractService.getContractStatus()
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          this.contractStatusOptions = res.data.data;
        }
      });
    tireSizeService.getAll()
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.items) {
          this.tireSizeOptions = res.data.items;
        }
      });
    tireWearService.getAll()
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.items) {
          this.tireWearOptions = res.data.items;
        }
      });
    tireWidthService.getAll()
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.items) {
          this.tireWidthOptions = res.data.items;
        }
      });
  }

  private setDefaultTireBrand() {
    // Disabled because spec update
    // tireBrandService.findByName('ブリヂストン')
    //   .then((res) => {
    //     if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
    //       this.tireBrandDefaultOption = res.data.data;
    //     }
    //   });
  }

  private showButtonStatus(contract: TireStoringContract) {
    if (!contract || !contract.period || !contract.status || !contract.slipNo) {
      this.showSwitchButton = false;
      return;
    }
    // Hide when period === 6 months or status is Completed or already switch tire (slipNo end with S)
    const slipNoArray: string[] = contract.slipNo.split('-');
    if (slipNoArray.length < 3) {
      this.showSwitchButton = false;
      return;
    }
    const contractPart: string = slipNoArray[2];
    this.showSwitchButton = (contract.period !== 0)
                         && (contract.status !== ContractStatusEnum.COMPLETED)
                         && (contractPart.indexOf('F') > -1);
  }

  private getDateTime(dateTime: number): string {
    return dateTime ? this.$moment(dateTime).format('YYYY-MM-DD HH:mm') : '';
  }

  private getDayLeft(item: TireStoringContract): string {
    if (item && item.contractEndDate) {
      const currentDate = this.$moment();
      const endDate = this.$moment(item.contractEndDate);
      return endDate.diff(currentDate, 'd').toString();
    }
    return '';
  }

  private getPeriod(period: number): string {
    const currentPeriod = this.contractPeriodOptions.find((option) => option.value === period);
    return (currentPeriod && currentPeriod.text) ? currentPeriod.text : '';
  }

  private getStatus(status: number): string {
    const currentStatus = this.contractStatusOptions.find((option) => option.value === status);
    return (currentStatus && currentStatus.text) ? currentStatus.text : '';
  }

  private loadTireType(tireType: number) {
    if (tireType === TireTypeEnum.SUMMER) {
      return 'enum.tire_type.summer';
    } else if (tireType === TireTypeEnum.WINTER) {
      return 'enum.tire_type.winter';
    } else {
      return null;
    }
  }

  private switchTire() {
    this.showSwitchButton = false;
    if (!this.tireContract.id || !this.tireContract.customer || !this.tireContract.customer.id) {
      return;
    }
    // Move to T102 in edit mode
    this.$router.push({
      name: 'routes.tire_register',
      query: {
        'customerId': this.tireContract.customer.id,
        'contractId': this.tireContract.id,
        'switchTire': 'true',
      },
    });
  }

  private editContractAndCustomer() {
    if (this.tireContract.id) {
      this.$router.push({
        name: 'routes.user_register.input',
        query: {
          'contractId': this.tireContract.id,
        },
      });
    }
  }

  private editContract() {
    if (this.tireContract.id && this.tireContract.customer.id) {
      this.$router.push({
        name: 'routes.tire_register',
        query: {
          'customerId': this.tireContract.customer.id,
          'contractId': this.tireContract.id,
        },
      });
    }
  }

  private completeContract() {
    if (!this.tireContract.id) {
      return;
    }
    tireStoringContractService.setContractCompleted([this.tireContract.id])
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS) {
          this.showConfirmRenewModal = true;
        }
      });
  }

  private goToPickUpPage() {
    this.$router.push({ name: 'routes.delivery-calendar' });
  }

  private renewContract() {
    if (this.tireContract.id) {
      this.$router.push({
        name: 'routes.user_register.input',
        query: {
          'contractId': this.tireContract.id,
          'reNew': 'true',
        },
      });
    }
  }

  private cancelPickupContract() {
    if (!this.tireContract.id) {
      return;
    }
    tireStoringContractService.cancelPickup([this.tireContract.id])
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS) {
          toastService.successMessage('view.tire_contract_detail.msg.cancel_pickup_success');
          this.loadTireContract(this.tireContract.id);
        }
      });
  }

  private cancelDeliveryContract() {
    if (!this.tireContract.id) {
      return;
    }
    tireStoringContractService.cancelDelivery([this.tireContract.id])
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS) {
          toastService.successMessage('view.tire_contract_detail.msg.cancel_delivery_success');
          this.loadTireContract(this.tireContract.id);
        }
      });
  }

  private goToHomePage() {
    this.$router.push({ name: 'routes.home' });
  }

  private showAllScratchImage() {
    if (this.tabIndex === 0 && (this.$refs.tireSummerCard as any)) {
      (this.$refs.tireSummerCard as any).forEach((item: any) => {
        item.showScratchImage = !item.showScratchImage;
      });
    } else if ((this.$refs.tireWinterCard as any)) {
      (this.$refs.tireWinterCard as any).forEach((item: any) => {
        item.showScratchImage = !item.showScratchImage;
      });
    }
  }

  get canSwitch() {
    return this.tireContract
      && (this.tireContract.status === ContractStatusEnum.IN_DELIVERY
      || this.tireContract.status === ContractStatusEnum.INSPECTION_COMPLETED 
      || this.tireContract.status == ContractStatusEnum.ACCEPTED_DELIVERY) ? true : false;
  }

  private exportPdf() {
    if (!this.$route.params.id) {
      return;
    }
    tireStoringContractService.exportContract(this.$route.params.id)
      .then(() => {
          // Do nothing
      });
  }

  private getDayOfWeek(value: number) {
    switch (value) {
      case 0: return this.$t("common.day_of_week.sunday").toString();
      case 1: return this.$t("common.day_of_week.monday").toString();
      case 2: return this.$t("common.day_of_week.tuesday").toString();
      case 3: return this.$t("common.day_of_week.wednesday").toString();
      case 4: return this.$t("common.day_of_week.thursday").toString();
      case 5: return this.$t("common.day_of_week.friday").toString();
      case 6: return this.$t("common.day_of_week.saturday").toString();
    }
  }

  get periodIsSixMonthSummer() {
    if (this.tireContract && this.tireContract.period === ContractPeriodEnum.SIX_MONTH && this.tireContract.tireType === TireTypeEnum.SUMMER) {
      return true;
    }
    return false;
  }

  get periodIsSixMonthWinter() {
    if (this.tireContract && this.tireContract.period === ContractPeriodEnum.SIX_MONTH && this.tireContract.tireType === TireTypeEnum.WINTER) {
      return true;
    }
    return false;
  }

  private formatDate(date: Date) {
    return Utils.getDate(date);
  }

  private valueDateStatus(): any {
    const checkStatus = this.tireContract.status;

    if (checkStatus === ContractStatusEnum.REQUEST_PICKUP || checkStatus === ContractStatusEnum.ACCEPTED_PICKUP ) {
      return this.tireContract.pickupDate ? this.formatDate(this.$moment(this.tireContract.pickupDate).format('YYYY-MM-DD')) 
        + " ("+ this.getDayOfWeek(new Date(this.tireContract.pickupDate).getUTCDay()) + ")" : null;
    } else if (checkStatus === ContractStatusEnum.REQUEST_DELIVERY || checkStatus === ContractStatusEnum.ACCEPTED_DELIVERY 
      || checkStatus === ContractStatusEnum.IN_DELIVERY) {
      return this.tireContract.deliveryDate ? this.formatDate(this.$moment(this.tireContract.deliveryDate).format('YYYY-MM-DD')) 
        + " ("+ this.getDayOfWeek(new Date(this.tireContract.deliveryDate).getUTCDay()) + ")" : null;
    } else {
      return
    }
  }

  private endDateNumber(): any {
    return this.$moment(this.tireContract.contractEndDate).utc().startOf('day').diff(this.$moment().utc().add(7, 'hours'), 'days').toString();
  }

  private getStepsValue(): any{
    let valueSteps;
    const valueTypeOfContract = this.getPeriod(this.tireContract.period || 1);
    const typeContractCheck = this.tireContract.slipNo;
    if(typeContractCheck != null){
      let typeContract = typeContractCheck.split('-');
      if(typeContract.length < 3){
        return;
      }
      let contractPart = typeContract[2].slice(-1);
      typeContract[2] = contractPart.replace("F", "S");

    if (valueTypeOfContract == 'enum.tire_contract.twelve_months'){
      if(contractPart === 'F'){
        switch (this.tireContract.status){
          case ContractStatusEnum.STORE_KEEPING:        
              valueSteps = ValueSteps.VALUE_TWO_TO_TWO;
              break;
          case ContractStatusEnum.REQUEST_PICKUP: case ContractStatusEnum.ACCEPTED_PICKUP: case ContractStatusEnum.IN_WAREHOUSE: 
          case ContractStatusEnum.REQUEST_DELIVERY: case ContractStatusEnum.ACCEPTED_DELIVERY: case ContractStatusEnum.IN_DELIVERY: 
          case ContractStatusEnum.INSPECTION_COMPLETED: 
              valueSteps = ValueSteps.VALUE_ONE_TO_TWO;
              break;
          default:
              valueSteps = ValueSteps.VALUE_ZERO_TO_TWO;
              break;
          }
      } else{
        switch (this.tireContract.status){
          case ContractStatusEnum.STORE_KEEPING:          
              valueSteps = ValueSteps.VALUE_ONE_TO_TWO;
              break;
          default:
              valueSteps = ValueSteps.VALUE_ZERO_TO_TWO;
              break;
          }
      }
    } else{
      if (contractPart === 'F'){
        switch (this.tireContract.status){
          case ContractStatusEnum.STORE_KEEPING:          
              valueSteps = ValueSteps.VALUE_ONE_TO_ONE;
              break;
          default:
              valueSteps = ValueSteps.VALUE_ZERO_TO_ONE;
              break;
          }
      } else{
         return;
      }
    }
  }
    return valueSteps;
  }

  private isEnableEditLocationNo() {
    return this.$store.state.user.role === RoleEnum.ROLE_ADMIN
      || this.$store.state.user.role === RoleEnum.ROLE_WAREHOUSE
      || this.$store.state.user.role === RoleEnum.ROLE_COMPANY_ADMIN;
  }

  private getMsgErrorLocationNo(): InputError | [] {
    const erros = this.errors.find(
      (e: any) => e.field === 'rackLocation' && e.message.length > 0 
                || e.field === 'columnLocation' && e.message.length > 0
                || e.field === 'rowLocation' && e.message.length > 0
      );
    return erros || [];
  }

}
